import type { BoardFilters } from '../types'

// Per-user persisted Board view (sort + filters). A widget instance is
// scoped to one project, so the external id is a sufficient key. Best-
// effort: storage may be disabled or hold a stale/corrupt blob — every
// path falls back to an empty view rather than throwing into render.
const PREFIX = 'mhosaic.boardView.'

export function loadBoardView(externalId: string): BoardFilters {
  try {
    const raw = localStorage.getItem(PREFIX + externalId)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? (parsed as BoardFilters) : {}
  } catch {
    return {}
  }
}

export function saveBoardView(externalId: string, view: BoardFilters): void {
  try {
    localStorage.setItem(PREFIX + externalId, JSON.stringify(view))
  } catch {
    /* storage disabled / quota — non-fatal, just no persistence */
  }
}
